import script from "./POIMap.vue?vue&type=script&setup=true&lang=js"
export * from "./POIMap.vue?vue&type=script&setup=true&lang=js"

import "./POIMap.vue?vue&type=style&index=0&id=5afb8ae1&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/RJKESzs2/0/roolz/poi-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afb8ae1"]])

export default __exports__